import * as React from 'react';

var _path, _path2;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.325 11.524l.03-.454c.212.025.552.054.963.054 1.09 0 2.68-.21 3.714-1.276 1.67-1.721 1.176-4.928 1.154-5.064a.305.305 0 00-.248-.255c-.132-.022-3.245-.533-4.916 1.188a3.942 3.942 0 00-.85 1.397c-.466-2.785-1.524-3.951-1.589-4.02a.295.295 0 00-.425-.007.317.317 0 00-.007.439c.011.012.635.702 1.109 2.31-.035-.04-.07-.08-.108-.118-1.67-1.722-4.784-1.21-4.915-1.189a.305.305 0 00-.248.255c-.022.136-.517 3.343 1.153 5.065 1.036 1.066 2.624 1.276 3.715 1.276.37 0 .68-.024.894-.048-.008.146-.018.295-.03.446C11.44 11.675 8 15.31 8 19.758 8 24.303 11.589 28 16 28s8-3.697 8-8.242c0-4.433-3.414-8.057-7.675-8.234zm1.123-5.368c1.218-1.254 3.463-1.122 4.172-1.043.076.729.206 3.04-1.014 4.297-1.217 1.254-3.463 1.122-4.171 1.043a8.838 8.838 0 01-.045-.966c.007-1.012.19-2.437 1.058-3.331zm-5.88 3.254c-1.217-1.254-1.089-3.568-1.013-4.298.71-.078 2.954-.21 4.171 1.044.706.727.958 1.81 1.032 2.733.014.248.023.504.026.77a8.8 8.8 0 01-.045.794c-.708.08-2.951.213-4.171-1.043zM16 27.38c-4.08 0-7.398-3.42-7.398-7.622s3.319-7.622 7.398-7.622c4.08 0 7.398 3.42 7.398 7.622S20.079 27.38 16 27.38z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.418a.306.306 0 00-.302.31c0 .172.135.31.301.31 2.872 0 5.208 2.407 5.208 5.366 0 .172.135.31.301.31a.306.306 0 00.302-.31c0-3.3-2.607-5.986-5.81-5.986z"
  })));
}

export { SvgApple as default };